import Teleport from './src/teleport2.mjs';
export { teleportProps } from './src/teleport.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTeleport = withInstall(Teleport);

export { ElTeleport, ElTeleport as default };
//# sourceMappingURL=index.mjs.map
